var Ee = Object.defineProperty;
var ie = (t) => {
  throw TypeError(t);
};
var Ve = (t, e, s) => e in t ? Ee(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var ne = (t, e, s) => Ve(t, typeof e != "symbol" ? e + "" : e, s), R = (t, e, s) => e.has(t) || ie("Cannot " + s);
var o = (t, e, s) => (R(t, e, "read from private field"), s ? s.call(t) : e.get(t)), f = (t, e, s) => e.has(t) ? ie("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, s), g = (t, e, s, i) => (R(t, e, "write to private field"), i ? i.call(t, s) : e.set(t, s), s), d = (t, e, s) => (R(t, e, "access private method"), s);
let b = Object.getPrototypeOf, O, x, u, C, ae = { isConnected: 1 }, Ae = 1e3, z, H = {}, Oe = b(ae), le = b(b), w, ce = (t, e, s, i) => (t ?? (setTimeout(s, i), /* @__PURE__ */ new Set())).add(e), de = (t, e, s) => {
  let i = u;
  u = e;
  try {
    return t(s);
  } catch (n) {
    return console.error(n), s;
  } finally {
    u = i;
  }
}, $ = (t) => t.filter((e) => {
  var s;
  return (s = e._dom) == null ? void 0 : s.isConnected;
}), ue = (t) => z = ce(z, t, () => {
  for (let e of z)
    e._bindings = $(e._bindings), e._listeners = $(e._listeners);
  z = w;
}, Ae), B = {
  get val() {
    var t;
    return (t = u == null ? void 0 : u._getters) == null || t.add(this), this.rawVal;
  },
  get oldVal() {
    var t;
    return (t = u == null ? void 0 : u._getters) == null || t.add(this), this._oldVal;
  },
  set val(t) {
    var e;
    (e = u == null ? void 0 : u._setters) == null || e.add(this), t !== this.rawVal && (this.rawVal = t, this._bindings.length + this._listeners.length ? (x == null || x.add(this), O = ce(O, this, xe)) : this._oldVal = t);
  }
}, he = (t) => ({
  __proto__: B,
  rawVal: t,
  _oldVal: t,
  _bindings: [],
  _listeners: []
}), T = (t, e) => {
  let s = { _getters: /* @__PURE__ */ new Set(), _setters: /* @__PURE__ */ new Set() }, i = { f: t }, n = C;
  C = [];
  let a = de(t, s, e);
  a = (a ?? document).nodeType ? a : new Text(a);
  for (let r of s._getters)
    s._setters.has(r) || (ue(r), r._bindings.push(i));
  for (let r of C) r._dom = a;
  return C = n, i._dom = a;
}, Y = (t, e = he(), s) => {
  let i = { _getters: /* @__PURE__ */ new Set(), _setters: /* @__PURE__ */ new Set() }, n = { f: t, s: e };
  n._dom = s ?? (C == null ? void 0 : C.push(n)) ?? ae, e.val = de(t, i, e.rawVal);
  for (let a of i._getters)
    i._setters.has(a) || (ue(a), a._listeners.push(n));
  return e;
}, fe = (t, ...e) => {
  for (let s of e.flat(1 / 0)) {
    let i = b(s ?? 0), n = i === B ? T(() => s.val) : i === le ? T(s) : s;
    n != w && t.append(n);
  }
  return t;
}, ge = (t, e, ...s) => {
  var S;
  let [{ is: i, ...n }, ...a] = b(s[0] ?? 0) === Oe ? s : [{}, ...s], r = t ? document.createElementNS(t, e, { is: i }) : document.createElement(e, { is: i });
  for (let [h, _] of Object.entries(n)) {
    let D = (A) => A ? Object.getOwnPropertyDescriptor(A, h) ?? D(b(A)) : w, V = e + "," + h, c = H[V] ?? (H[V] = ((S = D(b(r))) == null ? void 0 : S.set) ?? 0), F = h.startsWith("on") ? (A, je) => {
      let se = h.slice(2);
      r.removeEventListener(se, je), r.addEventListener(se, A);
    } : c ? c.bind(r) : r.setAttribute.bind(r, h), U = b(_ ?? 0);
    h.startsWith("on") || U === le && (_ = Y(_), U = B), U === B ? T(() => (F(_.val, _._oldVal), r)) : F(_);
  }
  return fe(r, a);
}, re = (t) => ({ get: (e, s) => ge.bind(w, t, s) }), pe = (t, e) => e ? e !== t && t.replaceWith(e) : t.remove(), xe = () => {
  let t = 0, e = [...O].filter((i) => i.rawVal !== i._oldVal);
  do {
    x = /* @__PURE__ */ new Set();
    for (let i of new Set(e.flatMap((n) => n._listeners = $(n._listeners))))
      Y(i.f, i.s, i._dom), i._dom = w;
  } while (++t < 100 && (e = [...x]).length);
  let s = [...O].filter((i) => i.rawVal !== i._oldVal);
  O = w;
  for (let i of new Set(s.flatMap((n) => n._bindings = $(n._bindings))))
    pe(i._dom, T(i.f, i._dom)), i._dom = w;
  for (let i of s) i._oldVal = i.rawVal;
};
const M = {
  tags: new Proxy((t) => new Proxy(ge, re(t)), re()),
  hydrate: (t, e) => pe(t, T(e, t)),
  add: fe,
  state: he,
  derive: Y
};
/**
 * Button component.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since 0.9.0
 */
function N(t, e) {
  const s = [
    "privcy__button",
    t.type && `privcy__button--${t.type}`
  ].join(" ");
  return M.tags.button(
    {
      class: s,
      onclick: t.onClick
    },
    e
  );
}
/**
 * Banner component.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since 0.9.0
 */
const { dialog: Te, div: q, h2: Ie, h3: Pe, ul: De, li: Fe, p: ze, span: Ne, label: Le, input: $e, form: Be } = M.tags;
function Me(t) {
  const {
    controller: e,
    categories: s,
    isCustomizing: i,
    title: n,
    description: a,
    strings: r
  } = t, S = () => e.allowedCategories;
  let h = S();
  const _ = (c) => {
    c.preventDefault(), i.val = !i.val;
  }, D = (c) => {
    S().includes(c) ? h = h.filter(
      (F) => F !== c
    ) : h.push(c);
  }, V = () => s.toArray().map(
    (c) => Fe(
      { class: "privcy__category" },
      Pe({ class: "privcy__category__name" }, c.name),
      ze(
        { class: "privcy__category__description" },
        c.description
      ),
      Le(
        {
          class: "privcy__category__checkbox"
        },
        $e({
          type: "checkbox",
          checked: S().includes(c.id),
          onchange: () => D(c.id)
        }),
        Ne(`${r.categories.enable} ${c.name}`)
      )
    )
  );
  return Te(
    { class: "privcy", onclose: () => i.val = !1 },
    Ie({ class: "privcy__title" }, n),
    q({
      class: "privcy__description",
      innerHTML: a
    }),
    () => i.val ? De({ class: "privcy__categories" }, V()) : "",
    Be(
      {
        class: "privcy__buttons",
        method: "dialog"
      },
      N(
        { type: "customize", onClick: _ },
        () => i.val ? r.buttons.back : r.buttons.customize
      ),
      () => i.val ? q(
        {
          class: "privcy__buttons__choices"
        },
        N(
          {
            type: "acceptSelected",
            onClick: () => e.updateConsent(h)
          },
          r.buttons.saveSettings
        )
      ) : q(
        {
          class: "privcy__buttons__choices"
        },
        N(
          {
            type: "acceptAll",
            onClick: () => e.updateConsent(s.IDs)
          },
          r.buttons.acceptAll
        ),
        N(
          {
            type: "rejectAll",
            onClick: () => e.updateConsent([])
          },
          r.buttons.rejectAll
        )
      )
    )
  );
}
/**
 * Categories class.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since 0.6.0
 */
class Ue {
  /**
   * Constructor for the Categories class.
   * @param data - Record containing category data.
   */
  constructor(e) {
    /**
     * Array containing the IDs of categories.
     */
    ne(this, "IDs");
    this.data = e, this.IDs = Object.keys(e);
  }
  /**
   * Converts the category data into an array of objects.
   * @returns An array of category objects with id, name, and description.
   */
  toArray() {
    return Object.entries(this.data).map(([e, s]) => ({
      id: e,
      ...s
    }));
  }
}
/*! typescript-cookie v1.0.6 | MIT */
const _e = (t) => encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape), ye = (t) => encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent), Z = decodeURIComponent, K = (t) => (t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent));
function Re(t) {
  return t = Object.assign({}, t), typeof t.expires == "number" && (t.expires = new Date(Date.now() + t.expires * 864e5)), t.expires != null && (t.expires = t.expires.toUTCString()), Object.entries(t).filter(([e, s]) => s != null && s !== !1).map(([e, s]) => s === !0 ? `; ${e}` : `; ${e}=${s.split(";")[0]}`).join("");
}
function be(t, e, s) {
  const i = /(?:^|; )([^=]*)=([^;]*)/g, n = {};
  let a;
  for (; (a = i.exec(document.cookie)) != null; )
    try {
      const r = s(a[1]);
      if (n[r] = e(a[2], r), t === r)
        break;
    } catch {
    }
  return t != null ? n[t] : n;
}
const oe = Object.freeze({
  decodeName: Z,
  decodeValue: K,
  encodeName: _e,
  encodeValue: ye
}), ee = Object.freeze({
  path: "/"
});
function te(t, e, s = ee, { encodeValue: i = ye, encodeName: n = _e } = {}) {
  return document.cookie = `${n(t)}=${i(e, t)}${Re(s)}`;
}
function Ce(t, { decodeValue: e = K, decodeName: s = Z } = {}) {
  return be(t, e, s);
}
function He({ decodeValue: t = K, decodeName: e = Z } = {}) {
  return be(void 0, t, e);
}
function me(t, e = ee) {
  te(t, "", Object.assign({}, e, {
    expires: -1
  }));
}
function W(t, e) {
  const s = {
    set: function(n, a, r) {
      return te(n, a, Object.assign({}, this.attributes, r), {
        encodeValue: this.converter.write
      });
    },
    get: function(n) {
      if (arguments.length === 0)
        return He(this.converter.read);
      if (n != null)
        return Ce(n, this.converter.read);
    },
    remove: function(n, a) {
      me(n, Object.assign({}, this.attributes, a));
    },
    withAttributes: function(n) {
      return W(this.converter, Object.assign({}, this.attributes, n));
    },
    withConverter: function(n) {
      return W(Object.assign({}, this.converter, n), this.attributes);
    }
  }, i = {
    attributes: { value: Object.freeze(e) },
    converter: { value: Object.freeze(t) }
  };
  return Object.create(s, i);
}
W({ read: oe.decodeValue, write: oe.encodeValue }, ee);
/**
 * Create iframe broadcast channel.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since @next
 */
function ve() {
  return new BroadcastChannel("privcy:iframe-fallback");
}
/**
 * Controller class.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since 0.6.0
 */
var p, I, l, G, we, J, Q, ke, L;
class qe {
  constructor(e, s) {
    f(this, l);
    /**
     * All category IDs.
     */
    f(this, p);
    f(this, I);
    this.cookiePrefix = e, g(this, p, s.IDs), g(this, I, ve()), this.isFirstVisit || this.loadEmbeds(), this.loadIframeFallbacks();
  }
  /**
   * Get all categories user has consented to.
   */
  get allowedCategories() {
    return o(this, p).filter(
      (e) => d(this, l, J).call(this, e) === "true"
    );
  }
  /**
   * Get all categories user has not consented to.
   */
  get rejectedCategories() {
    return o(this, p).filter(
      (e) => d(this, l, J).call(this, e) === "false"
    );
  }
  /**
   * Get overall consent status.
   */
  get consentStatus() {
    const e = this.rejectedCategories.length > 0, s = this.allowedCategories.length > 0;
    if ([...this.rejectedCategories, ...this.allowedCategories].length === o(this, p).length) {
      if (e && !s)
        return "rejected";
      if (s && !e)
        return "allowed";
      if (s && e)
        return "customized";
    }
  }
  /**
   * User has not interacted with banner.
   */
  get isFirstVisit() {
    return this.consentStatus === void 0;
  }
  /**
   * Get all DOM elements controlled by Privcy.
   */
  get controlledElements() {
    return d(this, l, G).call(this);
  }
  /**
   * Update consent.
   */
  updateConsent(e) {
    d(this, l, we).call(this, e), this.loadEmbeds();
  }
  /**
   * Consent to individual category.
   */
  consentToCategory(e) {
    this.updateConsent([...this.allowedCategories, e]);
  }
  /**
   * Load all scripts and iframes.
   */
  loadEmbeds() {
    d(this, l, G).call(this).forEach((e) => {
      const s = e.getAttribute("data-privcy");
      if (typeof s != "string") return;
      const i = JSON.parse(s);
      if (typeof i.category != "string" || !this.allowedCategories.includes(i.category)) {
        if (e instanceof HTMLIFrameElement && typeof i.fallback == "string") {
          e.src = i.fallback;
          return;
        }
        e.src && (e.src = ""), e instanceof HTMLScriptElement && (e.type = "text/plain");
        return;
      }
      typeof i.src == "string" && (e.src = i.src), e instanceof HTMLScriptElement && (e.type = "application/javascript", e.innerText = e.innerText);
    });
  }
  /**
   * Populate iframes in case it cannot be loaded.
   */
  loadIframeFallbacks() {
    this.controlledElements.forEach((e) => {
      if (!(e instanceof HTMLIFrameElement))
        return;
      const s = JSON.parse(
        e.getAttribute("data-privcy") ?? ""
      ), i = s == null ? void 0 : s.category;
      if (!this.allowedCategories.includes(i) && s != null && s.fallback) {
        o(this, I).onmessage = (n) => {
          typeof n.data.allowCategory == "string" && o(this, p).includes(n.data.allowCategory) && this.consentToCategory(n.data.allowCategory);
        };
        return;
      }
    });
  }
}
p = new WeakMap(), I = new WeakMap(), l = new WeakSet(), /**
 * Get all scripts and iframs in DOM.
 */
G = function() {
  return document.querySelectorAll("script[data-privcy], iframe[data-privcy]");
}, /**
 * Set allowed categories.
 */
we = function(e) {
  for (const s of o(this, p))
    d(this, l, ke).call(this, s), e.includes(s) ? d(this, l, Q).call(this, s, "true") : d(this, l, Q).call(this, s, "false");
}, /**
 * Get cookie.
 */
J = function(e) {
  return Ce(d(this, l, L).call(this, e));
}, /**
 * Set cookie with preconfigured settings.
 */
Q = function(e, s) {
  return te(d(this, l, L).call(this, e), s, {
    expires: 180,
    sameSite: "strict",
    secure: !0,
    path: "/"
  });
}, /**
 * Remove cookie.
 */
ke = function(e) {
  me(d(this, l, L).call(this, e));
}, /**
 * Cookie name.
 */
L = function(e) {
  return `${this.cookiePrefix}__consent___${e}`;
};
/**!
 * Cookie/Privacy consent banner script.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @license BSD-3-Clause
 * @copyright 2024 Simon Lagerlöf
 * @since 0.0.1
 */
var P, j, y, m, v, E, k, Se, X;
class We {
  constructor(e) {
    f(this, k);
    f(this, P);
    f(this, j);
    f(this, y);
    f(this, m);
    f(this, v);
    f(this, E);
    g(this, E, e.strings), g(this, P, ve()), g(this, j, new Ue(e.categories)), g(this, y, new qe(
      e.cookiePrefix ?? "privcy",
      o(this, j)
    )), e.target instanceof Element || (e.target = document.createElement("privcy-banner"), document.body.prepend(e.target)), g(this, m, {
      controller: o(this, y),
      categories: o(this, j),
      isCustomizing: M.state(!1),
      title: e.title,
      description: e.description,
      strings: o(this, k, Se)
    }), g(this, v, Me(o(this, m))), M.add(e.target, o(this, v)), o(this, y).isFirstVisit && o(this, v).showModal(), d(this, k, X).call(this), o(this, P).onmessage = (s) => {
      s.data.displayBanner && this.openSettings();
    };
  }
  /**
   * Reload scripts and iframes.
   */
  reload() {
    o(this, y).loadEmbeds(), o(this, y).loadIframeFallbacks(), d(this, k, X).call(this);
  }
  /**
   * Open settings.
   */
  openSettings() {
    o(this, m).isCustomizing.val = !0, o(this, v).showModal();
  }
}
P = new WeakMap(), j = new WeakMap(), y = new WeakMap(), m = new WeakMap(), v = new WeakMap(), E = new WeakMap(), k = new WeakSet(), Se = function() {
  var e, s;
  return {
    categories: {
      enable: "Enable",
      ...(e = o(this, E)) == null ? void 0 : e.categories
    },
    buttons: {
      acceptAll: "Accept all",
      rejectAll: "Reject all",
      customize: "Customize settings",
      saveSettings: "Save settings",
      back: "Back",
      ...(s = o(this, E)) == null ? void 0 : s.buttons
    }
  };
}, /**
 * Event listener to open banner again.
 */
X = function() {
  o(this, m) && document.querySelectorAll("[data-privcy-display-banner]").forEach(
    (e) => e.addEventListener("click", () => {
      this.openSettings();
    })
  );
};
typeof window < "u" && (window.Privcy = We);
export {
  We as default
};
